module.exports = __webpack_public_path__ + "img/17-1_05.d2867caf.jpg";